export default "__VITE_ASSET__SsjR22oc__"